module.exports = __webpack_public_path__ + "img/multiple-translation-channels.d767589a.png";